import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import { authorsMetaTag } from 'Store/constants/authorsMetaTag';
import { findDescAndTitle } from 'Utils/findMetaTagForAuthors';
import { getCanonicalArgsFromPathname } from 'Utils/getCanonicalArgsFromPathname';

const Authors = loadable(() => pMinDelay(import('./Authors'), 300), {
  fallback: <Loading />
});

const AuthorsDetail = loadable(() => pMinDelay(import('./AuthorsDetail'), 300), {
  fallback: <Loading />,
  ssr: false
});

const AsyncAuthors = props => {
  let authorName = '';
  let tabTitleAndDescObject;

  // Dynamic title and description bind dom
  if (props.match.params?.user) {
    const temp = props.match.params?.user?.split('-');
    temp?.pop();
    temp?.forEach(element => {
      authorName = authorName + element.charAt(0).toUpperCase() + element.slice(1) + ' ';
    });
  } else {
    tabTitleAndDescObject = findDescAndTitle(props.match.params?.tabName);
  }
  const canonicalArgs = getCanonicalArgsFromPathname(props);

  let title = tabTitleAndDescObject?.title;
  let description = tabTitleAndDescObject?.desc;

  if (props.page !== 'yazarlar') {
    if (authorName.includes('Bahista') || authorName.includes('bahista')) {
      title = `${ authorName } : ${authorsMetaTag.detailPageBahista.title}`;
      description = `${ authorName } ${authorsMetaTag.detailPageBahista.desc}`;
    } else {
      title = `${ authorName } ${authorsMetaTag.detailPage.title}`;
      description = `${ authorName } ${authorsMetaTag.detailPage.desc}`;
    }
  }

  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green`
      },
      title: title,
      meta: [{
        name: 'description',
        content: description,
      },
      { property: 'og:description',
        content: description
      }],
      link: [
        canonicalArgs
      ]
    }
  };

  const PageContent = () => {
    switch (props?.page) {
      case 'yazar-detay':
        return <AuthorsDetail { ...props } />;
      case 'yazarlar':
        return <Authors { ...props }/>;
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      { PageContent() }
    </ApplicationLayout>
  );
};

AsyncAuthors.propTypes = {
  userAgent: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  page: PropTypes.string
};

export default AsyncAuthors;
